import axios from "axios";
import ErrorParser from './error.parser';

const UsersService = {
  authenticate: async function (username, password) {
    const requestData = {
      method: "post",
      url: "/api/users/authenticate",
      data: {
        username: username,
        password: password
      }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      let message = "Incorrect user name or password";
      if (error.response.status == 404 || error.response.status == 500)
        message = "Something unexpected happened.";
      throw new Error(message);
    }
  },
  signOut: async function () {
    const requestData = {
      method: "post",
      url: "/api/users/signout",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  me: async function (username, password) {
    const requestData = {
      method: "get",
      url: "/api/users/me",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  permissions: function () {
    return {
        //users/auth/permission_enum
        network: 1,
        observations: 2,
        exporting: 3,
        processing: 4,
        qualitycontrol: 5,
        users: 6,
        allnetworks: 7
      }
  },
};

export default UsersService;

